<template>
    <div>
        <e-dialog
                dialog-title="提示"
                :center-dialog-visible="showSubSupplierTip"
                popup-width="400px"
                :closeBtn="true"
                buttonTip="前往"
                @resetPopupData="handleClose"
                @submitPopupData="submitPopupData">
            <div>该订单供应商不在供应商清单中，请先维护供应商清单，石化订单方可关联此原材料订单，是否前往“运营中心-原材料管理-供应商维护”维护供应商清单？</div>
        </e-dialog>
    </div>
</template>

<script>
import eDialog from '@/components/common/e-dialog.vue';

export default {
  name: 'subSupplierDialog',
  components: {
    eDialog
  },
  props: {
    showSubSupplierTip: Boolean,
  },
  methods: {
    submitPopupData() {
      this.$router.push({path: "/supplierListMaintenance"})
    },
    handleClose() {
      this.$emit('update:showSubSupplierTip', false);
    },
  },
};
</script>

<style scoped lang="scss">

</style>
